import type { Project } from "../Types/Project";

export const projects: Project[] = [
  {
    title: "Model-based testing of RESTful applications (Master’s thesis)",
    keywords: ["Model-based testing", "Session Types", "Scala", "GitLab"],
    year: "2023"
  },
  {
    title: "Multi-classification of hate speech (Bachelor’s thesis)",
    keywords: ["Machine Learning", "Python"],
    year: "2020"
  },
  {
    title: "Dungeon of Doom",
    keywords: ["MonoGame", "Design Patterns"],
    year: "2019"
  }
];
